var React = require('react');

function RhythymIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2 9H4V21H2V9ZM8 3H10V21H8V3ZM14 12H16V21H14V12ZM20 6H22V21H20V6Z","fill":"url(#paint0_linear_420_16200)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear_420_16200","x1":"7.12494","y1":"5.25011","x2":"15.4776","y2":"19.8851","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.3125","stopColor":"#5D44B7","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#FFA6C1","key":1})]))]);
}

RhythymIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = RhythymIcon;

RhythymIcon.default = RhythymIcon;
